import React from "react";
import PropTypes from "prop-types";
import { Row, Checkbox } from "antd";

const LastDay = (props) => {
  const { checked, onChange } = props;
  return (
    <Row>
      <Checkbox value="lastday" checked={checked} onChange={onChange}>
        End of Month
      </Checkbox>
    </Row>
  );
};

LastDay.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default LastDay;
